import moment from "moment/moment";
import React, { createRef } from "react";
import { Offcanvas } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Joi from "joi-browser";

//  Images
import closeIcon from "include/images/dark-close-icon.svg";
import emptyIcon from "include/images/nrf.svg";
import userIcon from "include/images/user.png";
import loadingIcon from "include/images/loader-grey.svg";
import filterIcon from "include/images/filter-icon.svg";

//  Components
import Form from "common/form/form";
import Loader from "common/loader";
import { getTelegram, loadBattleGameParticipants } from "store/telegram";
import SortIcon from "common/sortIcon";
import { isEmpty, pickBy } from "lodash";
import NextButton from "common/form/submitButton";

class ParticipantsFlyer extends Form {
  scrollRef = React.createRef();
  ref = createRef(null);
  state = {
    data: {
      userName: "",
      firstName: "",
      lastName: "",
    },
    loading: false,
    loadingMore: false,
    sorting: { sort: "createdAt", order: "desc" },
    page: 1,
    errors: {},
  };
  handleLoadMore = (entries) => {
    const target = entries[0];
    if (target?.isIntersecting) {
      const { battleGameParticipants, battleGameParticipantsTotalEntries } = this.props.getTelegram;
      if (!this.state.loadingMore && battleGameParticipants?.length < battleGameParticipantsTotalEntries) {
        this.setState({ loadingMore: true });
        const data = { ...this.state.data };
        const sorting = { ...this.state.sorting };
        const payLoad = {
          userName: data?.userName,
          firstName: data?.firstName,
          lastName: data?.lastName,
          page: this.state.page + 1,
          sort: sorting?.sort,
          order: sorting?.order,
        };
        var params = pickBy(payLoad, function (value, key) {
          return value !== "";
        });
        params.page = this.state.page + 1;
        this.props.loadBattleGameParticipants(this.props.battleGameId, params, false, (res) =>
          this.setState({ loadingMore: false, page: this.state.page + 1 }),
        );
        this.observer.disconnect();
      }
    }
  };
  observer = new IntersectionObserver(this.handleLoadMore, {
    threshold: 0.2,
  });
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.showModal && this.props.showModal !== prevProps.showModal) {
      this.setState({ loading: true });
      const params = { ...this.state.sorting, page: this.state.page };

      this.props.loadBattleGameParticipants(this.props.battleGameId, params, true, (res) => {
        this.setState({ loading: false });
      });
    }
    if (!this.props.showModal && this.props.showModal !== prevProps.showModal) {
      this.setState({
        loading: false,
        loadingMore: false,
        page: 1,
      });
    }

    if (
      !this.props.getTelegram.battleGameParticipantsLoading &&
      this.props.getTelegram.battleGameParticipantsLoading !== prevProps.getTelegram.battleGameParticipantsLoading
    ) {
      this.ref.current.complete();
    }
    if (
      this.props.getTelegram.battleGameParticipantsLoading &&
      this.props.getTelegram.battleGameParticipantsLoading !== prevProps.getTelegram.battleGameParticipantsLoading
    ) {
      this.ref.current.continuousStart();
    }

    if (
      this.props.getTelegram?.battleGameParticipants?.length <
      this.props.getTelegram?.battleGameParticipantsTotalEntries
    ) {
      if (this.observer && this.scrollRef?.current) {
        this.observer.observe(this.scrollRef.current);
      }
    }
  };
  onRefChange = (node, i) => {
    const { battleGameParticipants, battleGameParticipantsTotalEntries } = this.props.getTelegram;

    if (
      i === battleGameParticipants?.length - 1 &&
      battleGameParticipants?.length < battleGameParticipantsTotalEntries
    ) {
      this.scrollRef.current = node;
    }
  };
  //  Filters
  searchFilters = () => {
    const data = { ...this.state.data };
    const sorting = { ...this.state.sorting };

    const payLoad = {
      userName: data?.userName,
      firstName: data?.firstName,
      lastName: data?.lastName,

      sort: sorting?.sort,
      order: sorting?.order,
    };

    this.setState({ loadingFilters: true });
    var params = pickBy(payLoad, function (value, key) {
      return value !== "";
    });
    params.page = this.state.page;

    this.props.loadBattleGameParticipants(this.props.battleGameId, params, true, (userRes) => {
      if (userRes?.status === 200) {
        const data = { ...this.state.data };
        const appliedFilters = {};
        Object.keys(this.state.data).forEach((key) => {
          if (!isEmpty(data[key])) {
            appliedFilters[key] = data[key];
          }
        });
        this.setState({
          appliedFilters,
          loading: false,
          loadingMore: false,
          loadingFilters: false,
        });
      } else this.setState({ loading: false, loadingFilters: false });
    });
  };
  sort = (e, type) => {
    if (e) e.preventDefault();
    const sorting = { ...this.state.sorting };
    sorting.order = sorting?.sort === type && sorting.order === "desc" ? "asc" : "desc";
    sorting.sort = type;

    this.setState({ sorting, page: 1 }, () => {
      this.searchFilters();
    });
  };

  resetFilters = (e) => {
    e.preventDefault();
    this.setState(
      {
        data: {
          userName: "",
          firstName: "",
          lastName: "",
        },
        page: 1,
      },
      () => this.searchFilters(),
    );
  };
  schema = {
    userName: Joi.string().allow(""),
    firstName: Joi.string().allow(""),
    lastName: Joi.string().allow(""),
  };
  render() {
    const { loading } = this.state;
    const { battleGameParticipants, battleGameParticipantsTotalEntries } = this.props.getTelegram;
    return (
      <>
        <Loader loaderRef={this.ref} />
        <Offcanvas
          className={"offcanvas offcanvas-end custom-offcanvas-pannel custom-offcanvas-pannel2"}
          show={this.props.showModal}
          onHide={this.props.toggleModal}
          id="rewardPannel"
          placement="right"
          name="rewardPannel"
          backdrop={true}
        >
          <Offcanvas.Header className="offCanvas-header gap-5">
            <div className="d-flex align-items-center justify-content-between w-100">
              <h5>
                Participants{" "}
                {!loading && `(${battleGameParticipantsTotalEntries > 0 ? battleGameParticipantsTotalEntries : ""})`}
              </h5>
              <div className="filter-menu-box d-flex align-items-center ms-auto">
                <div className="fmb-box">
                  <a
                    href="#!"
                    className="filter-link-box"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ showFilters: !this.state.showFilters });
                    }}
                  >
                    <img src={filterIcon} /> <span>Filters</span>
                  </a>
                </div>
              </div>
            </div>
            <div
              className="btn_close pointer"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={this.props.toggleModal}
            >
              <img src={closeIcon} alt="" />
            </div>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {this.state.showFilters && (
              <div className="fwc-head ">
                <div className="fwc-inner">
                  <ul className="filter-mode-list question-filter-mode-list d-flex flex-wrap align-items-center">
                    <li className="flex-fill">
                      <div className="fml-box">{this.renderInput("userName", "Username")}</div>
                    </li>
                    <li className="flex-fill">
                      <div className="fml-box">{this.renderInput("firstName", "First Name")}</div>
                    </li>
                    <li className="flex-fill">
                      <div className="fml-box">{this.renderInput("lastName", "Last Name")}</div>
                    </li>
                  </ul>
                  <div className="fwc-btn d-flex align-items-center justify-content-end">
                    <NextButton
                      handleSubmit={this.resetFilters}
                      classData="btn-text pointer"
                      label="Reset"
                      loading={this.state.loadingReset}
                    />
                    <NextButton
                      handleSubmit={() => {
                        this.setState(
                          {
                            page: 1,
                          },
                          () => this.searchFilters(),
                        );
                      }}
                      classData="btn btn-primary btn-sm"
                      label="Search"
                      loading={this.state.loadingFilters}
                    />
                  </div>
                </div>{" "}
                {!isEmpty(this.state.appliedFilters) && (
                  <div className="filter-tag-container d-flex align-items-center ">
                    <div className="fwc-left">
                      <div className="filter-tag-list">
                        <p>Filter applied :</p>
                        {Object.keys(this.state.appliedFilters).map((key) => (
                          <div className="filter-tag-item">
                            <span className="camelCase">
                              {key === "userName"
                                ? "Username"
                                : key === "firstName"
                                ? "First Name"
                                : key === "lastName"
                                ? "Last Name"
                                : key}
                            </span>{" "}
                            : {this.state.appliedFilters[key]}
                            <a
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();

                                this.setState(
                                  {
                                    data: {
                                      ...this.state.data,
                                      [key]: key === "startDate" || key === "endDate" ? null : "",
                                    },
                                    page: 1,
                                  },
                                  this.searchFilters,
                                );
                              }}
                            >
                              <img src={closeIcon} alt="" />
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            <div className="">
              <div className="fwc-body">
                {!this.state.loading && (
                  <div className="table-responsive">
                    {battleGameParticipants?.length === 0 ? (
                      <div className="fwc-body">
                        <div className="no-record-found-container">
                          <div className="nfr-box">
                            <img src={emptyIcon} alt="No Record Found" />
                            <div className="nrf-text">
                              <h5>No Records Found!</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <table className="table large-table">
                        <thead>
                          <tr>
                            <th>Users</th>
                            <th>
                              Stage
                              <SortIcon
                                sortIconType="stage"
                                handleSort={(e) => this.sort(e, "stage")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                            <th>Level</th>
                            <th>Equipped Gears</th>
                            <th>Win</th>
                            <th>
                              Date
                              <SortIcon
                                sortIconType="createdAt"
                                handleSort={(e) => this.sort(e, "createdAt")}
                                sort={this.state.sorting?.sort}
                                order={this.state.sorting?.order}
                              />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {battleGameParticipants?.map((participant, i) => (
                            <tr key={participant?._id} ref={(node) => this.onRefChange(node, i)}>
                              <td className="td-img-group d-flex align-items-start ">
                                <div className="td-img round-img m-right-2">
                                  {participant?.userDetails?.image ? (
                                    <img
                                      src={process.env.REACT_APP_CDN + participant?.userDetails?.image?.small}
                                      alt=""
                                    />
                                  ) : (
                                    <img src={userIcon} alt="" />
                                  )}
                                </div>

                                <div>
                                  {participant?.userDetails?.firstName} {participant?.userDetails?.lastName}
                                  <br />
                                  {participant?.userDetails?.userName} <br />
                                  {participant?.userDetails?.telegramId}
                                </div>
                              </td>
                              <td>{participant?.stage}</td>
                              <td>{participant?.level}</td>
                              <td>{participant?.gearDetails?.map((gear) => gear?.name)?.join(", ")}</td>
                              <td className="ust-tag">
                                <span
                                  className={`w-100 text-center d-block ${participant?.isWin ? "active" : "suspended"}`}
                                >
                                  {participant?.isWin ? "Yes" : "No"}
                                </span>
                              </td>

                              <td>
                                <div className="small-text">
                                  {moment(participant?.updatedAt).format("MM/DD/YYYY")}
                                  <br /> <small> {moment(participant?.updatedAt).format("hh:mm a")}</small>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                )}
              </div>
            </div>
            {this.state.loadingMore && (
              <div className="w-100 d-flex justify-content-center load-more">
                <img src={loadingIcon} className="fa-spin" alt="" />
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadBattleGameParticipants: (id, params, fresh, callback) =>
    dispatch(loadBattleGameParticipants(id, params, fresh, callback)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantsFlyer));
